import { useState } from 'react';
import { useAddAddacsReport, useRefreshReports } from '@app/sdk';

const reasons: any[] = [
  { code: '0', name: 'Refer to payer' },
  { code: '1', name: 'Instruction Cancelled' },
  { code: '2', name: 'Payer deceased' },
  { code: '3', name: 'Account transferred' },
  { code: 'B', name: 'Account Closed' },
  { code: 'C', name: 'Account transferred to a different account/branch of the bank/building society' },
  { code: 'D', name: 'Advance notice disputed' },
  { code: 'E', name: 'Instruction amended' },
  { code: 'R', name: 'Instruction reinstated' },
];

export function Addacs(props: {
  accountNumber: string;
  customerName: string;
  sortCode: string;
  bankAccountNumber: string;
  serviceUserNumber: string;
}) {
  const [reasonCode, setReasonCode] = useState(undefined as string);
  const [newSortCode, setNewSortCode] = useState(undefined as string);
  const [newBankAccountNumber, setNewBankAccountNumber] = useState(undefined as string);
  const refreshReports = useRefreshReports();
  const { mutateAsync: addAddacsReport, isPending: submitting } = useAddAddacsReport();
  const handleSubmit = async (e) => {
    e.preventDefault();

    await addAddacsReport({
      reasonCode: reasonCode,
      accountNumber: props.accountNumber,
      customerName: props.customerName,
      sortCode: props.sortCode,
      bankAccountNumber: props.bankAccountNumber,
      newSortCode: newSortCode,
      newBankAccountNumber: newBankAccountNumber,
      serviceUserNumber: props.serviceUserNumber
    });

    setTimeout(() => {
      refreshReports();
    }, 100);
  };

  return (
    <>
      <section>
        <form className="ui card" onSubmit={(e) => handleSubmit(e)}>
          <div className="content">
            <div className="ui form">
              <div className="field">
                <label>Reason</label>
                <select onChange={(e) => setReasonCode(e.target.value)} value={reasonCode}>
                  <option>--Select a reason--</option>
                  {reasons.map((r) => (
                    <option key={r.code} value={r.code}>
                      {r.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="field">
                <label>New Sort Code</label>
                <input
                  type="text"
                  value={newSortCode || ''}
                  onChange={(e) => setNewSortCode(e.target.value)}
                  disabled={submitting}
                />
                {newSortCode && newSortCode.length != 6 && (
                  <div className="ui pointing red basic label">Sort code must be 6 digits</div>
                )}
              </div>
              <div className="field">
                <label>New Bank Account Number</label>
                <input
                  type="text"
                  value={newBankAccountNumber || ''}
                  onChange={(e) => setNewBankAccountNumber(e.target.value)}
                  disabled={submitting}
                />
                {newBankAccountNumber && newBankAccountNumber.length != 8 && (
                  <div className="ui pointing red basic label">Bank account number must be 8 digits</div>
                )}
              </div>
            </div>
          </div>
          <button className={`ui button ${submitting && 'loading'}`} type="submit" disabled={!reasonCode}>
            <span>Add</span>
          </button>
        </form>
      </section>
    </>
  );
}
